import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';

const LegalPage = ({ title, lastUpdated, children }) => {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-paper pt-32 pb-20">
      <div className="max-w-3xl mx-auto px-6">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-ink/50 hover:text-ink transition-colors mb-12 group"
        >
          <SafeIcon name="ArrowLeft" className="group-hover:-translate-x-1 transition-transform" />
          Back to Home
        </Link>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="text-4xl md:text-5xl font-semibold tracking-tight text-ink mb-4">
            {title}
          </h1>
          <p className="text-sm font-medium text-ink/40 mb-12 uppercase tracking-widest">
            Last updated: {lastUpdated}
          </p>
          
          <div className="prose prose-slate max-w-none prose-headings:text-ink prose-p:text-ink/70 prose-p:font-light prose-p:leading-relaxed prose-strong:text-ink prose-li:text-ink/70 prose-li:font-light">
            {children}
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default LegalPage;